__turbopack_context__.v({
  "pdp-quantity": "E3y7pW_pdp-quantity",
  "pdp-quantity--compact": "E3y7pW_pdp-quantity--compact",
  "quantity": "E3y7pW_quantity",
});
